ux-popover-panel,
.ux-popover-panel {
  background-color: var(--ux-popover-panel-bg-color);
  border: var(--ux-popover-panel-border-width) solid var(--ux-popover-panel-border-color);
  box-shadow: var(--ux-popover-panel-shadow);
  box-sizing: border-box;
  display: block;
  max-width: 100%;
  padding: var(--ux-popover-panel-padding);
  position: relative;
}

.ux-popover-panel--primary {
  --ux-popover-panel-border-color: var(--ux-popover-primary-border-color);
  --ux-popover-panel-border-width: var(--ux-popover-primary-border-width);
}

.ux-popover-panel--secondary {
  --ux-popover-panel-border-color: var(--ux-popover-secondary-border-color);
  --ux-popover-panel-border-width: var(--ux-popover-secondary-border-width);
}
